import { UnknownError, NetworkError, ConnectionAbortedError, TimeoutError, InvalidSdkConfigurationError, InvalidRegionOrHostError, InvalidRegionError, InvalidHostError } from "@smash-sdk/core";
import { GenericError as UnsubscribeSubscriptionGenericError } from "./types/UnsubscribeSubscription/UnsubscribeSubscriptionError";
import { InvalidParameterError as UnsubscribeSubscriptionInvalidParameterError } from "./types/UnsubscribeSubscription/UnsubscribeSubscriptionError";
import { UnauthorizedError as UnsubscribeSubscriptionUnauthorizedError } from "./types/UnsubscribeSubscription/UnsubscribeSubscriptionError";
import { ForbiddenError as UnsubscribeSubscriptionForbiddenError } from "./types/UnsubscribeSubscription/UnsubscribeSubscriptionError";
import { NotFoundError as UnsubscribeSubscriptionNotFoundError } from "./types/UnsubscribeSubscription/UnsubscribeSubscriptionError";
import { InternalServerError as UnsubscribeSubscriptionInternalServerError } from "./types/UnsubscribeSubscription/UnsubscribeSubscriptionError";
import { BadGatewayError as UnsubscribeSubscriptionBadGatewayError } from "./types/UnsubscribeSubscription/UnsubscribeSubscriptionError";
import { GatewayTimeoutError as UnsubscribeSubscriptionGatewayTimeoutError } from "./types/UnsubscribeSubscription/UnsubscribeSubscriptionError";
import { GenericError as UpdateInformationsGenericError } from "./types/UpdateInformations/UpdateInformationsError";
import { InvalidVatNumberError as UpdateInformationsInvalidVatNumberError } from "./types/UpdateInformations/UpdateInformationsError";
import { InvalidParameterError as UpdateInformationsInvalidParameterError } from "./types/UpdateInformations/UpdateInformationsError";
import { UnauthorizedError as UpdateInformationsUnauthorizedError } from "./types/UpdateInformations/UpdateInformationsError";
import { VatNumberNotUpdatableError as UpdateInformationsVatNumberNotUpdatableError } from "./types/UpdateInformations/UpdateInformationsError";
import { ForbiddenError as UpdateInformationsForbiddenError } from "./types/UpdateInformations/UpdateInformationsError";
import { NotFoundError as UpdateInformationsNotFoundError } from "./types/UpdateInformations/UpdateInformationsError";
import { InternalServerError as UpdateInformationsInternalServerError } from "./types/UpdateInformations/UpdateInformationsError";
import { ServiceUnavailableError as UpdateInformationsServiceUnavailableError } from "./types/UpdateInformations/UpdateInformationsError";
import { BadGatewayError as UpdateInformationsBadGatewayError } from "./types/UpdateInformations/UpdateInformationsError";
import { GatewayTimeoutError as UpdateInformationsGatewayTimeoutError } from "./types/UpdateInformations/UpdateInformationsError";
import { GenericError as CreateStripeSetupIntentGenericError } from "./types/CreateStripeSetupIntent/CreateStripeSetupIntentError";
import { UnauthorizedError as CreateStripeSetupIntentUnauthorizedError } from "./types/CreateStripeSetupIntent/CreateStripeSetupIntentError";
import { InvalidPaymentProviderError as CreateStripeSetupIntentInvalidPaymentProviderError } from "./types/CreateStripeSetupIntent/CreateStripeSetupIntentError";
import { ForbiddenError as CreateStripeSetupIntentForbiddenError } from "./types/CreateStripeSetupIntent/CreateStripeSetupIntentError";
import { NotFoundError as CreateStripeSetupIntentNotFoundError } from "./types/CreateStripeSetupIntent/CreateStripeSetupIntentError";
import { InternalServerError as CreateStripeSetupIntentInternalServerError } from "./types/CreateStripeSetupIntent/CreateStripeSetupIntentError";
import { BadGatewayError as CreateStripeSetupIntentBadGatewayError } from "./types/CreateStripeSetupIntent/CreateStripeSetupIntentError";
import { GatewayTimeoutError as CreateStripeSetupIntentGatewayTimeoutError } from "./types/CreateStripeSetupIntent/CreateStripeSetupIntentError";
import { GenericError as CreateSubscriptionGenericError } from "./types/CreateSubscription/CreateSubscriptionError";
import { InvalidParameterError as CreateSubscriptionInvalidParameterError } from "./types/CreateSubscription/CreateSubscriptionError";
import { UnauthorizedError as CreateSubscriptionUnauthorizedError } from "./types/CreateSubscription/CreateSubscriptionError";
import { InvalidPaymentInformationsError as CreateSubscriptionInvalidPaymentInformationsError } from "./types/CreateSubscription/CreateSubscriptionError";
import { InvalidPlanError as CreateSubscriptionInvalidPlanError } from "./types/CreateSubscription/CreateSubscriptionError";
import { ForbiddenError as CreateSubscriptionForbiddenError } from "./types/CreateSubscription/CreateSubscriptionError";
import { NotFoundError as CreateSubscriptionNotFoundError } from "./types/CreateSubscription/CreateSubscriptionError";
import { InternalServerError as CreateSubscriptionInternalServerError } from "./types/CreateSubscription/CreateSubscriptionError";
import { BadGatewayError as CreateSubscriptionBadGatewayError } from "./types/CreateSubscription/CreateSubscriptionError";
import { GatewayTimeoutError as CreateSubscriptionGatewayTimeoutError } from "./types/CreateSubscription/CreateSubscriptionError";
import { GenericError as ExecutePaypalPaymentGenericError } from "./types/ExecutePaypalPayment/ExecutePaypalPaymentError";
import { InvalidParameterError as ExecutePaypalPaymentInvalidParameterError } from "./types/ExecutePaypalPayment/ExecutePaypalPaymentError";
import { UnauthorizedError as ExecutePaypalPaymentUnauthorizedError } from "./types/ExecutePaypalPayment/ExecutePaypalPaymentError";
import { ForbiddenError as ExecutePaypalPaymentForbiddenError } from "./types/ExecutePaypalPayment/ExecutePaypalPaymentError";
import { ConflictError as ExecutePaypalPaymentConflictError } from "./types/ExecutePaypalPayment/ExecutePaypalPaymentError";
import { InternalServerError as ExecutePaypalPaymentInternalServerError } from "./types/ExecutePaypalPayment/ExecutePaypalPaymentError";
import { BadGatewayError as ExecutePaypalPaymentBadGatewayError } from "./types/ExecutePaypalPayment/ExecutePaypalPaymentError";
import { GatewayTimeoutError as ExecutePaypalPaymentGatewayTimeoutError } from "./types/ExecutePaypalPayment/ExecutePaypalPaymentError";
import { GenericError as ExecuteStripePaymentGenericError } from "./types/ExecuteStripePayment/ExecuteStripePaymentError";
import { InvalidParameterError as ExecuteStripePaymentInvalidParameterError } from "./types/ExecuteStripePayment/ExecuteStripePaymentError";
import { UnauthorizedError as ExecuteStripePaymentUnauthorizedError } from "./types/ExecuteStripePayment/ExecuteStripePaymentError";
import { InvalidPaymentProviderError as ExecuteStripePaymentInvalidPaymentProviderError } from "./types/ExecuteStripePayment/ExecuteStripePaymentError";
import { ForbiddenError as ExecuteStripePaymentForbiddenError } from "./types/ExecuteStripePayment/ExecuteStripePaymentError";
import { NotFoundError as ExecuteStripePaymentNotFoundError } from "./types/ExecuteStripePayment/ExecuteStripePaymentError";
import { ConflictError as ExecuteStripePaymentConflictError } from "./types/ExecuteStripePayment/ExecuteStripePaymentError";
import { InternalServerError as ExecuteStripePaymentInternalServerError } from "./types/ExecuteStripePayment/ExecuteStripePaymentError";
import { BadGatewayError as ExecuteStripePaymentBadGatewayError } from "./types/ExecuteStripePayment/ExecuteStripePaymentError";
import { GatewayTimeoutError as ExecuteStripePaymentGatewayTimeoutError } from "./types/ExecuteStripePayment/ExecuteStripePaymentError";
import { GenericError as GetGroupGenericError } from "./types/GetGroup/GetGroupError";
import { InvalidParameterError as GetGroupInvalidParameterError } from "./types/GetGroup/GetGroupError";
import { UnauthorizedError as GetGroupUnauthorizedError } from "./types/GetGroup/GetGroupError";
import { ForbiddenError as GetGroupForbiddenError } from "./types/GetGroup/GetGroupError";
import { NotFoundError as GetGroupNotFoundError } from "./types/GetGroup/GetGroupError";
import { InternalServerError as GetGroupInternalServerError } from "./types/GetGroup/GetGroupError";
import { BadGatewayError as GetGroupBadGatewayError } from "./types/GetGroup/GetGroupError";
import { GatewayTimeoutError as GetGroupGatewayTimeoutError } from "./types/GetGroup/GetGroupError";
import { GenericError as GetInformationsGenericError } from "./types/GetInformations/GetInformationsError";
import { UnauthorizedError as GetInformationsUnauthorizedError } from "./types/GetInformations/GetInformationsError";
import { ForbiddenError as GetInformationsForbiddenError } from "./types/GetInformations/GetInformationsError";
import { NotFoundError as GetInformationsNotFoundError } from "./types/GetInformations/GetInformationsError";
import { InternalServerError as GetInformationsInternalServerError } from "./types/GetInformations/GetInformationsError";
import { BadGatewayError as GetInformationsBadGatewayError } from "./types/GetInformations/GetInformationsError";
import { GatewayTimeoutError as GetInformationsGatewayTimeoutError } from "./types/GetInformations/GetInformationsError";
import { GenericError as GetInvoiceGenericError } from "./types/GetInvoice/GetInvoiceError";
import { InvalidParameterError as GetInvoiceInvalidParameterError } from "./types/GetInvoice/GetInvoiceError";
import { UnauthorizedError as GetInvoiceUnauthorizedError } from "./types/GetInvoice/GetInvoiceError";
import { ForbiddenError as GetInvoiceForbiddenError } from "./types/GetInvoice/GetInvoiceError";
import { NotFoundError as GetInvoiceNotFoundError } from "./types/GetInvoice/GetInvoiceError";
import { InternalServerError as GetInvoiceInternalServerError } from "./types/GetInvoice/GetInvoiceError";
import { BadGatewayError as GetInvoiceBadGatewayError } from "./types/GetInvoice/GetInvoiceError";
import { GatewayTimeoutError as GetInvoiceGatewayTimeoutError } from "./types/GetInvoice/GetInvoiceError";
import { GenericError as GetPlanGenericError } from "./types/GetPlan/GetPlanError";
import { InvalidParameterError as GetPlanInvalidParameterError } from "./types/GetPlan/GetPlanError";
import { UnauthorizedError as GetPlanUnauthorizedError } from "./types/GetPlan/GetPlanError";
import { ForbiddenError as GetPlanForbiddenError } from "./types/GetPlan/GetPlanError";
import { NotFoundError as GetPlanNotFoundError } from "./types/GetPlan/GetPlanError";
import { InternalServerError as GetPlanInternalServerError } from "./types/GetPlan/GetPlanError";
import { BadGatewayError as GetPlanBadGatewayError } from "./types/GetPlan/GetPlanError";
import { GatewayTimeoutError as GetPlanGatewayTimeoutError } from "./types/GetPlan/GetPlanError";
import { GenericError as GetPlanGroupGenericError } from "./types/GetPlanGroup/GetPlanGroupError";
import { InvalidParameterError as GetPlanGroupInvalidParameterError } from "./types/GetPlanGroup/GetPlanGroupError";
import { UnauthorizedError as GetPlanGroupUnauthorizedError } from "./types/GetPlanGroup/GetPlanGroupError";
import { ForbiddenError as GetPlanGroupForbiddenError } from "./types/GetPlanGroup/GetPlanGroupError";
import { NotFoundError as GetPlanGroupNotFoundError } from "./types/GetPlanGroup/GetPlanGroupError";
import { InternalServerError as GetPlanGroupInternalServerError } from "./types/GetPlanGroup/GetPlanGroupError";
import { BadGatewayError as GetPlanGroupBadGatewayError } from "./types/GetPlanGroup/GetPlanGroupError";
import { GatewayTimeoutError as GetPlanGroupGatewayTimeoutError } from "./types/GetPlanGroup/GetPlanGroupError";
import { GenericError as GetStripePaymentMethodGenericError } from "./types/GetStripePaymentMethod/GetStripePaymentMethodError";
import { UnauthorizedError as GetStripePaymentMethodUnauthorizedError } from "./types/GetStripePaymentMethod/GetStripePaymentMethodError";
import { InvalidModeOrPaymentProviderError as GetStripePaymentMethodInvalidModeOrPaymentProviderError } from "./types/GetStripePaymentMethod/GetStripePaymentMethodError";
import { ForbiddenError as GetStripePaymentMethodForbiddenError } from "./types/GetStripePaymentMethod/GetStripePaymentMethodError";
import { NotFoundError as GetStripePaymentMethodNotFoundError } from "./types/GetStripePaymentMethod/GetStripePaymentMethodError";
import { InternalServerError as GetStripePaymentMethodInternalServerError } from "./types/GetStripePaymentMethod/GetStripePaymentMethodError";
import { BadGatewayError as GetStripePaymentMethodBadGatewayError } from "./types/GetStripePaymentMethod/GetStripePaymentMethodError";
import { GatewayTimeoutError as GetStripePaymentMethodGatewayTimeoutError } from "./types/GetStripePaymentMethod/GetStripePaymentMethodError";
import { GenericError as GetSubscriptionGenericError } from "./types/GetSubscription/GetSubscriptionError";
import { UnauthorizedError as GetSubscriptionUnauthorizedError } from "./types/GetSubscription/GetSubscriptionError";
import { ForbiddenError as GetSubscriptionForbiddenError } from "./types/GetSubscription/GetSubscriptionError";
import { NotFoundError as GetSubscriptionNotFoundError } from "./types/GetSubscription/GetSubscriptionError";
import { InternalServerError as GetSubscriptionInternalServerError } from "./types/GetSubscription/GetSubscriptionError";
import { BadGatewayError as GetSubscriptionBadGatewayError } from "./types/GetSubscription/GetSubscriptionError";
import { GatewayTimeoutError as GetSubscriptionGatewayTimeoutError } from "./types/GetSubscription/GetSubscriptionError";
import { GenericError as InitiatePaypalPaymentGenericError } from "./types/InitiatePaypalPayment/InitiatePaypalPaymentError";
import { UnauthorizedError as InitiatePaypalPaymentUnauthorizedError } from "./types/InitiatePaypalPayment/InitiatePaypalPaymentError";
import { InvalidPaymentInformationsError as InitiatePaypalPaymentInvalidPaymentInformationsError } from "./types/InitiatePaypalPayment/InitiatePaypalPaymentError";
import { InvalidSubscriptionError as InitiatePaypalPaymentInvalidSubscriptionError } from "./types/InitiatePaypalPayment/InitiatePaypalPaymentError";
import { NoPaymentRequiredError as InitiatePaypalPaymentNoPaymentRequiredError } from "./types/InitiatePaypalPayment/InitiatePaypalPaymentError";
import { ForbiddenError as InitiatePaypalPaymentForbiddenError } from "./types/InitiatePaypalPayment/InitiatePaypalPaymentError";
import { NotFoundError as InitiatePaypalPaymentNotFoundError } from "./types/InitiatePaypalPayment/InitiatePaypalPaymentError";
import { InternalServerError as InitiatePaypalPaymentInternalServerError } from "./types/InitiatePaypalPayment/InitiatePaypalPaymentError";
import { BadGatewayError as InitiatePaypalPaymentBadGatewayError } from "./types/InitiatePaypalPayment/InitiatePaypalPaymentError";
import { GatewayTimeoutError as InitiatePaypalPaymentGatewayTimeoutError } from "./types/InitiatePaypalPayment/InitiatePaypalPaymentError";
import { GenericError as InitiateStripePaymentGenericError } from "./types/InitiateStripePayment/InitiateStripePaymentError";
import { UnauthorizedError as InitiateStripePaymentUnauthorizedError } from "./types/InitiateStripePayment/InitiateStripePaymentError";
import { InvalidPaymentInformationsError as InitiateStripePaymentInvalidPaymentInformationsError } from "./types/InitiateStripePayment/InitiateStripePaymentError";
import { InvalidSubscriptionError as InitiateStripePaymentInvalidSubscriptionError } from "./types/InitiateStripePayment/InitiateStripePaymentError";
import { NoPaymentRequiredError as InitiateStripePaymentNoPaymentRequiredError } from "./types/InitiateStripePayment/InitiateStripePaymentError";
import { ForbiddenError as InitiateStripePaymentForbiddenError } from "./types/InitiateStripePayment/InitiateStripePaymentError";
import { NotFoundError as InitiateStripePaymentNotFoundError } from "./types/InitiateStripePayment/InitiateStripePaymentError";
import { InternalServerError as InitiateStripePaymentInternalServerError } from "./types/InitiateStripePayment/InitiateStripePaymentError";
import { BadGatewayError as InitiateStripePaymentBadGatewayError } from "./types/InitiateStripePayment/InitiateStripePaymentError";
import { GatewayTimeoutError as InitiateStripePaymentGatewayTimeoutError } from "./types/InitiateStripePayment/InitiateStripePaymentError";
import { GenericError as ListGroupPlansGenericError } from "./types/ListGroupPlans/ListGroupPlansError";
import { InvalidParameterError as ListGroupPlansInvalidParameterError } from "./types/ListGroupPlans/ListGroupPlansError";
import { UnauthorizedError as ListGroupPlansUnauthorizedError } from "./types/ListGroupPlans/ListGroupPlansError";
import { ForbiddenError as ListGroupPlansForbiddenError } from "./types/ListGroupPlans/ListGroupPlansError";
import { NotFoundError as ListGroupPlansNotFoundError } from "./types/ListGroupPlans/ListGroupPlansError";
import { InternalServerError as ListGroupPlansInternalServerError } from "./types/ListGroupPlans/ListGroupPlansError";
import { BadGatewayError as ListGroupPlansBadGatewayError } from "./types/ListGroupPlans/ListGroupPlansError";
import { GatewayTimeoutError as ListGroupPlansGatewayTimeoutError } from "./types/ListGroupPlans/ListGroupPlansError";
import { GenericError as ListInvoicesGenericError } from "./types/ListInvoices/ListInvoicesError";
import { UnauthorizedError as ListInvoicesUnauthorizedError } from "./types/ListInvoices/ListInvoicesError";
import { ForbiddenError as ListInvoicesForbiddenError } from "./types/ListInvoices/ListInvoicesError";
import { InternalServerError as ListInvoicesInternalServerError } from "./types/ListInvoices/ListInvoicesError";
import { BadGatewayError as ListInvoicesBadGatewayError } from "./types/ListInvoices/ListInvoicesError";
import { GatewayTimeoutError as ListInvoicesGatewayTimeoutError } from "./types/ListInvoices/ListInvoicesError";
import { GenericError as ListSubscriptionLimitsGenericError } from "./types/ListSubscriptionLimits/ListSubscriptionLimitsError";
import { UnauthorizedError as ListSubscriptionLimitsUnauthorizedError } from "./types/ListSubscriptionLimits/ListSubscriptionLimitsError";
import { ForbiddenError as ListSubscriptionLimitsForbiddenError } from "./types/ListSubscriptionLimits/ListSubscriptionLimitsError";
import { InternalServerError as ListSubscriptionLimitsInternalServerError } from "./types/ListSubscriptionLimits/ListSubscriptionLimitsError";
import { BadGatewayError as ListSubscriptionLimitsBadGatewayError } from "./types/ListSubscriptionLimits/ListSubscriptionLimitsError";
import { GatewayTimeoutError as ListSubscriptionLimitsGatewayTimeoutError } from "./types/ListSubscriptionLimits/ListSubscriptionLimitsError";
export const errors = {
    UnsubscribeSubscription: {
        InvalidParameterError: UnsubscribeSubscriptionInvalidParameterError,
        UnauthorizedError: UnsubscribeSubscriptionUnauthorizedError,
        ForbiddenError: UnsubscribeSubscriptionForbiddenError,
        NotFoundError: UnsubscribeSubscriptionNotFoundError,
        InternalServerError: UnsubscribeSubscriptionInternalServerError,
        BadGatewayError: UnsubscribeSubscriptionBadGatewayError,
        GatewayTimeoutError: UnsubscribeSubscriptionGatewayTimeoutError,
        GenericError: UnsubscribeSubscriptionGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateInformations: {
        InvalidVatNumberError: UpdateInformationsInvalidVatNumberError,
        InvalidParameterError: UpdateInformationsInvalidParameterError,
        UnauthorizedError: UpdateInformationsUnauthorizedError,
        VatNumberNotUpdatableError: UpdateInformationsVatNumberNotUpdatableError,
        ForbiddenError: UpdateInformationsForbiddenError,
        NotFoundError: UpdateInformationsNotFoundError,
        InternalServerError: UpdateInformationsInternalServerError,
        ServiceUnavailableError: UpdateInformationsServiceUnavailableError,
        BadGatewayError: UpdateInformationsBadGatewayError,
        GatewayTimeoutError: UpdateInformationsGatewayTimeoutError,
        GenericError: UpdateInformationsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateStripeSetupIntent: {
        UnauthorizedError: CreateStripeSetupIntentUnauthorizedError,
        InvalidPaymentProviderError: CreateStripeSetupIntentInvalidPaymentProviderError,
        ForbiddenError: CreateStripeSetupIntentForbiddenError,
        NotFoundError: CreateStripeSetupIntentNotFoundError,
        InternalServerError: CreateStripeSetupIntentInternalServerError,
        BadGatewayError: CreateStripeSetupIntentBadGatewayError,
        GatewayTimeoutError: CreateStripeSetupIntentGatewayTimeoutError,
        GenericError: CreateStripeSetupIntentGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateSubscription: {
        InvalidParameterError: CreateSubscriptionInvalidParameterError,
        UnauthorizedError: CreateSubscriptionUnauthorizedError,
        InvalidPaymentInformationsError: CreateSubscriptionInvalidPaymentInformationsError,
        InvalidPlanError: CreateSubscriptionInvalidPlanError,
        ForbiddenError: CreateSubscriptionForbiddenError,
        NotFoundError: CreateSubscriptionNotFoundError,
        InternalServerError: CreateSubscriptionInternalServerError,
        BadGatewayError: CreateSubscriptionBadGatewayError,
        GatewayTimeoutError: CreateSubscriptionGatewayTimeoutError,
        GenericError: CreateSubscriptionGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ExecutePaypalPayment: {
        InvalidParameterError: ExecutePaypalPaymentInvalidParameterError,
        UnauthorizedError: ExecutePaypalPaymentUnauthorizedError,
        ForbiddenError: ExecutePaypalPaymentForbiddenError,
        ConflictError: ExecutePaypalPaymentConflictError,
        InternalServerError: ExecutePaypalPaymentInternalServerError,
        BadGatewayError: ExecutePaypalPaymentBadGatewayError,
        GatewayTimeoutError: ExecutePaypalPaymentGatewayTimeoutError,
        GenericError: ExecutePaypalPaymentGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ExecuteStripePayment: {
        InvalidParameterError: ExecuteStripePaymentInvalidParameterError,
        UnauthorizedError: ExecuteStripePaymentUnauthorizedError,
        InvalidPaymentProviderError: ExecuteStripePaymentInvalidPaymentProviderError,
        ForbiddenError: ExecuteStripePaymentForbiddenError,
        NotFoundError: ExecuteStripePaymentNotFoundError,
        ConflictError: ExecuteStripePaymentConflictError,
        InternalServerError: ExecuteStripePaymentInternalServerError,
        BadGatewayError: ExecuteStripePaymentBadGatewayError,
        GatewayTimeoutError: ExecuteStripePaymentGatewayTimeoutError,
        GenericError: ExecuteStripePaymentGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetGroup: {
        InvalidParameterError: GetGroupInvalidParameterError,
        UnauthorizedError: GetGroupUnauthorizedError,
        ForbiddenError: GetGroupForbiddenError,
        NotFoundError: GetGroupNotFoundError,
        InternalServerError: GetGroupInternalServerError,
        BadGatewayError: GetGroupBadGatewayError,
        GatewayTimeoutError: GetGroupGatewayTimeoutError,
        GenericError: GetGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetInformations: {
        UnauthorizedError: GetInformationsUnauthorizedError,
        ForbiddenError: GetInformationsForbiddenError,
        NotFoundError: GetInformationsNotFoundError,
        InternalServerError: GetInformationsInternalServerError,
        BadGatewayError: GetInformationsBadGatewayError,
        GatewayTimeoutError: GetInformationsGatewayTimeoutError,
        GenericError: GetInformationsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetInvoice: {
        InvalidParameterError: GetInvoiceInvalidParameterError,
        UnauthorizedError: GetInvoiceUnauthorizedError,
        ForbiddenError: GetInvoiceForbiddenError,
        NotFoundError: GetInvoiceNotFoundError,
        InternalServerError: GetInvoiceInternalServerError,
        BadGatewayError: GetInvoiceBadGatewayError,
        GatewayTimeoutError: GetInvoiceGatewayTimeoutError,
        GenericError: GetInvoiceGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetPlan: {
        InvalidParameterError: GetPlanInvalidParameterError,
        UnauthorizedError: GetPlanUnauthorizedError,
        ForbiddenError: GetPlanForbiddenError,
        NotFoundError: GetPlanNotFoundError,
        InternalServerError: GetPlanInternalServerError,
        BadGatewayError: GetPlanBadGatewayError,
        GatewayTimeoutError: GetPlanGatewayTimeoutError,
        GenericError: GetPlanGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetPlanGroup: {
        InvalidParameterError: GetPlanGroupInvalidParameterError,
        UnauthorizedError: GetPlanGroupUnauthorizedError,
        ForbiddenError: GetPlanGroupForbiddenError,
        NotFoundError: GetPlanGroupNotFoundError,
        InternalServerError: GetPlanGroupInternalServerError,
        BadGatewayError: GetPlanGroupBadGatewayError,
        GatewayTimeoutError: GetPlanGroupGatewayTimeoutError,
        GenericError: GetPlanGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetStripePaymentMethod: {
        UnauthorizedError: GetStripePaymentMethodUnauthorizedError,
        InvalidModeOrPaymentProviderError: GetStripePaymentMethodInvalidModeOrPaymentProviderError,
        ForbiddenError: GetStripePaymentMethodForbiddenError,
        NotFoundError: GetStripePaymentMethodNotFoundError,
        InternalServerError: GetStripePaymentMethodInternalServerError,
        BadGatewayError: GetStripePaymentMethodBadGatewayError,
        GatewayTimeoutError: GetStripePaymentMethodGatewayTimeoutError,
        GenericError: GetStripePaymentMethodGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSubscription: {
        UnauthorizedError: GetSubscriptionUnauthorizedError,
        ForbiddenError: GetSubscriptionForbiddenError,
        NotFoundError: GetSubscriptionNotFoundError,
        InternalServerError: GetSubscriptionInternalServerError,
        BadGatewayError: GetSubscriptionBadGatewayError,
        GatewayTimeoutError: GetSubscriptionGatewayTimeoutError,
        GenericError: GetSubscriptionGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InitiatePaypalPayment: {
        UnauthorizedError: InitiatePaypalPaymentUnauthorizedError,
        InvalidPaymentInformationsError: InitiatePaypalPaymentInvalidPaymentInformationsError,
        InvalidSubscriptionError: InitiatePaypalPaymentInvalidSubscriptionError,
        NoPaymentRequiredError: InitiatePaypalPaymentNoPaymentRequiredError,
        ForbiddenError: InitiatePaypalPaymentForbiddenError,
        NotFoundError: InitiatePaypalPaymentNotFoundError,
        InternalServerError: InitiatePaypalPaymentInternalServerError,
        BadGatewayError: InitiatePaypalPaymentBadGatewayError,
        GatewayTimeoutError: InitiatePaypalPaymentGatewayTimeoutError,
        GenericError: InitiatePaypalPaymentGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InitiateStripePayment: {
        UnauthorizedError: InitiateStripePaymentUnauthorizedError,
        InvalidPaymentInformationsError: InitiateStripePaymentInvalidPaymentInformationsError,
        InvalidSubscriptionError: InitiateStripePaymentInvalidSubscriptionError,
        NoPaymentRequiredError: InitiateStripePaymentNoPaymentRequiredError,
        ForbiddenError: InitiateStripePaymentForbiddenError,
        NotFoundError: InitiateStripePaymentNotFoundError,
        InternalServerError: InitiateStripePaymentInternalServerError,
        BadGatewayError: InitiateStripePaymentBadGatewayError,
        GatewayTimeoutError: InitiateStripePaymentGatewayTimeoutError,
        GenericError: InitiateStripePaymentGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListGroupPlans: {
        InvalidParameterError: ListGroupPlansInvalidParameterError,
        UnauthorizedError: ListGroupPlansUnauthorizedError,
        ForbiddenError: ListGroupPlansForbiddenError,
        NotFoundError: ListGroupPlansNotFoundError,
        InternalServerError: ListGroupPlansInternalServerError,
        BadGatewayError: ListGroupPlansBadGatewayError,
        GatewayTimeoutError: ListGroupPlansGatewayTimeoutError,
        GenericError: ListGroupPlansGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListInvoices: {
        UnauthorizedError: ListInvoicesUnauthorizedError,
        ForbiddenError: ListInvoicesForbiddenError,
        InternalServerError: ListInvoicesInternalServerError,
        BadGatewayError: ListInvoicesBadGatewayError,
        GatewayTimeoutError: ListInvoicesGatewayTimeoutError,
        GenericError: ListInvoicesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListSubscriptionLimits: {
        UnauthorizedError: ListSubscriptionLimitsUnauthorizedError,
        ForbiddenError: ListSubscriptionLimitsForbiddenError,
        InternalServerError: ListSubscriptionLimitsInternalServerError,
        BadGatewayError: ListSubscriptionLimitsBadGatewayError,
        GatewayTimeoutError: ListSubscriptionLimitsGatewayTimeoutError,
        GenericError: ListSubscriptionLimitsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UnsubscribeSubscriptionError: {
        InvalidParameterError: UnsubscribeSubscriptionInvalidParameterError,
        UnauthorizedError: UnsubscribeSubscriptionUnauthorizedError,
        ForbiddenError: UnsubscribeSubscriptionForbiddenError,
        NotFoundError: UnsubscribeSubscriptionNotFoundError,
        InternalServerError: UnsubscribeSubscriptionInternalServerError,
        BadGatewayError: UnsubscribeSubscriptionBadGatewayError,
        GatewayTimeoutError: UnsubscribeSubscriptionGatewayTimeoutError,
        GenericError: UnsubscribeSubscriptionGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateInformationsError: {
        InvalidVatNumberError: UpdateInformationsInvalidVatNumberError,
        InvalidParameterError: UpdateInformationsInvalidParameterError,
        UnauthorizedError: UpdateInformationsUnauthorizedError,
        VatNumberNotUpdatableError: UpdateInformationsVatNumberNotUpdatableError,
        ForbiddenError: UpdateInformationsForbiddenError,
        NotFoundError: UpdateInformationsNotFoundError,
        InternalServerError: UpdateInformationsInternalServerError,
        ServiceUnavailableError: UpdateInformationsServiceUnavailableError,
        BadGatewayError: UpdateInformationsBadGatewayError,
        GatewayTimeoutError: UpdateInformationsGatewayTimeoutError,
        GenericError: UpdateInformationsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateStripeSetupIntentError: {
        UnauthorizedError: CreateStripeSetupIntentUnauthorizedError,
        InvalidPaymentProviderError: CreateStripeSetupIntentInvalidPaymentProviderError,
        ForbiddenError: CreateStripeSetupIntentForbiddenError,
        NotFoundError: CreateStripeSetupIntentNotFoundError,
        InternalServerError: CreateStripeSetupIntentInternalServerError,
        BadGatewayError: CreateStripeSetupIntentBadGatewayError,
        GatewayTimeoutError: CreateStripeSetupIntentGatewayTimeoutError,
        GenericError: CreateStripeSetupIntentGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateSubscriptionError: {
        InvalidParameterError: CreateSubscriptionInvalidParameterError,
        UnauthorizedError: CreateSubscriptionUnauthorizedError,
        InvalidPaymentInformationsError: CreateSubscriptionInvalidPaymentInformationsError,
        InvalidPlanError: CreateSubscriptionInvalidPlanError,
        ForbiddenError: CreateSubscriptionForbiddenError,
        NotFoundError: CreateSubscriptionNotFoundError,
        InternalServerError: CreateSubscriptionInternalServerError,
        BadGatewayError: CreateSubscriptionBadGatewayError,
        GatewayTimeoutError: CreateSubscriptionGatewayTimeoutError,
        GenericError: CreateSubscriptionGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ExecutePaypalPaymentError: {
        InvalidParameterError: ExecutePaypalPaymentInvalidParameterError,
        UnauthorizedError: ExecutePaypalPaymentUnauthorizedError,
        ForbiddenError: ExecutePaypalPaymentForbiddenError,
        ConflictError: ExecutePaypalPaymentConflictError,
        InternalServerError: ExecutePaypalPaymentInternalServerError,
        BadGatewayError: ExecutePaypalPaymentBadGatewayError,
        GatewayTimeoutError: ExecutePaypalPaymentGatewayTimeoutError,
        GenericError: ExecutePaypalPaymentGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ExecuteStripePaymentError: {
        InvalidParameterError: ExecuteStripePaymentInvalidParameterError,
        UnauthorizedError: ExecuteStripePaymentUnauthorizedError,
        InvalidPaymentProviderError: ExecuteStripePaymentInvalidPaymentProviderError,
        ForbiddenError: ExecuteStripePaymentForbiddenError,
        NotFoundError: ExecuteStripePaymentNotFoundError,
        ConflictError: ExecuteStripePaymentConflictError,
        InternalServerError: ExecuteStripePaymentInternalServerError,
        BadGatewayError: ExecuteStripePaymentBadGatewayError,
        GatewayTimeoutError: ExecuteStripePaymentGatewayTimeoutError,
        GenericError: ExecuteStripePaymentGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetGroupError: {
        InvalidParameterError: GetGroupInvalidParameterError,
        UnauthorizedError: GetGroupUnauthorizedError,
        ForbiddenError: GetGroupForbiddenError,
        NotFoundError: GetGroupNotFoundError,
        InternalServerError: GetGroupInternalServerError,
        BadGatewayError: GetGroupBadGatewayError,
        GatewayTimeoutError: GetGroupGatewayTimeoutError,
        GenericError: GetGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetInformationsError: {
        UnauthorizedError: GetInformationsUnauthorizedError,
        ForbiddenError: GetInformationsForbiddenError,
        NotFoundError: GetInformationsNotFoundError,
        InternalServerError: GetInformationsInternalServerError,
        BadGatewayError: GetInformationsBadGatewayError,
        GatewayTimeoutError: GetInformationsGatewayTimeoutError,
        GenericError: GetInformationsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetInvoiceError: {
        InvalidParameterError: GetInvoiceInvalidParameterError,
        UnauthorizedError: GetInvoiceUnauthorizedError,
        ForbiddenError: GetInvoiceForbiddenError,
        NotFoundError: GetInvoiceNotFoundError,
        InternalServerError: GetInvoiceInternalServerError,
        BadGatewayError: GetInvoiceBadGatewayError,
        GatewayTimeoutError: GetInvoiceGatewayTimeoutError,
        GenericError: GetInvoiceGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetPlanError: {
        InvalidParameterError: GetPlanInvalidParameterError,
        UnauthorizedError: GetPlanUnauthorizedError,
        ForbiddenError: GetPlanForbiddenError,
        NotFoundError: GetPlanNotFoundError,
        InternalServerError: GetPlanInternalServerError,
        BadGatewayError: GetPlanBadGatewayError,
        GatewayTimeoutError: GetPlanGatewayTimeoutError,
        GenericError: GetPlanGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetPlanGroupError: {
        InvalidParameterError: GetPlanGroupInvalidParameterError,
        UnauthorizedError: GetPlanGroupUnauthorizedError,
        ForbiddenError: GetPlanGroupForbiddenError,
        NotFoundError: GetPlanGroupNotFoundError,
        InternalServerError: GetPlanGroupInternalServerError,
        BadGatewayError: GetPlanGroupBadGatewayError,
        GatewayTimeoutError: GetPlanGroupGatewayTimeoutError,
        GenericError: GetPlanGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetStripePaymentMethodError: {
        UnauthorizedError: GetStripePaymentMethodUnauthorizedError,
        InvalidModeOrPaymentProviderError: GetStripePaymentMethodInvalidModeOrPaymentProviderError,
        ForbiddenError: GetStripePaymentMethodForbiddenError,
        NotFoundError: GetStripePaymentMethodNotFoundError,
        InternalServerError: GetStripePaymentMethodInternalServerError,
        BadGatewayError: GetStripePaymentMethodBadGatewayError,
        GatewayTimeoutError: GetStripePaymentMethodGatewayTimeoutError,
        GenericError: GetStripePaymentMethodGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSubscriptionError: {
        UnauthorizedError: GetSubscriptionUnauthorizedError,
        ForbiddenError: GetSubscriptionForbiddenError,
        NotFoundError: GetSubscriptionNotFoundError,
        InternalServerError: GetSubscriptionInternalServerError,
        BadGatewayError: GetSubscriptionBadGatewayError,
        GatewayTimeoutError: GetSubscriptionGatewayTimeoutError,
        GenericError: GetSubscriptionGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InitiatePaypalPaymentError: {
        UnauthorizedError: InitiatePaypalPaymentUnauthorizedError,
        InvalidPaymentInformationsError: InitiatePaypalPaymentInvalidPaymentInformationsError,
        InvalidSubscriptionError: InitiatePaypalPaymentInvalidSubscriptionError,
        NoPaymentRequiredError: InitiatePaypalPaymentNoPaymentRequiredError,
        ForbiddenError: InitiatePaypalPaymentForbiddenError,
        NotFoundError: InitiatePaypalPaymentNotFoundError,
        InternalServerError: InitiatePaypalPaymentInternalServerError,
        BadGatewayError: InitiatePaypalPaymentBadGatewayError,
        GatewayTimeoutError: InitiatePaypalPaymentGatewayTimeoutError,
        GenericError: InitiatePaypalPaymentGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InitiateStripePaymentError: {
        UnauthorizedError: InitiateStripePaymentUnauthorizedError,
        InvalidPaymentInformationsError: InitiateStripePaymentInvalidPaymentInformationsError,
        InvalidSubscriptionError: InitiateStripePaymentInvalidSubscriptionError,
        NoPaymentRequiredError: InitiateStripePaymentNoPaymentRequiredError,
        ForbiddenError: InitiateStripePaymentForbiddenError,
        NotFoundError: InitiateStripePaymentNotFoundError,
        InternalServerError: InitiateStripePaymentInternalServerError,
        BadGatewayError: InitiateStripePaymentBadGatewayError,
        GatewayTimeoutError: InitiateStripePaymentGatewayTimeoutError,
        GenericError: InitiateStripePaymentGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListGroupPlansError: {
        InvalidParameterError: ListGroupPlansInvalidParameterError,
        UnauthorizedError: ListGroupPlansUnauthorizedError,
        ForbiddenError: ListGroupPlansForbiddenError,
        NotFoundError: ListGroupPlansNotFoundError,
        InternalServerError: ListGroupPlansInternalServerError,
        BadGatewayError: ListGroupPlansBadGatewayError,
        GatewayTimeoutError: ListGroupPlansGatewayTimeoutError,
        GenericError: ListGroupPlansGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListInvoicesError: {
        UnauthorizedError: ListInvoicesUnauthorizedError,
        ForbiddenError: ListInvoicesForbiddenError,
        InternalServerError: ListInvoicesInternalServerError,
        BadGatewayError: ListInvoicesBadGatewayError,
        GatewayTimeoutError: ListInvoicesGatewayTimeoutError,
        GenericError: ListInvoicesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListSubscriptionLimitsError: {
        UnauthorizedError: ListSubscriptionLimitsUnauthorizedError,
        ForbiddenError: ListSubscriptionLimitsForbiddenError,
        InternalServerError: ListSubscriptionLimitsInternalServerError,
        BadGatewayError: ListSubscriptionLimitsBadGatewayError,
        GatewayTimeoutError: ListSubscriptionLimitsGatewayTimeoutError,
        GenericError: ListSubscriptionLimitsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InvalidSdkConfigurationError,
    InvalidRegionOrHostError,
    InvalidRegionError,
    InvalidHostError,
};
